import { useContext, useEffect, useState } from 'react';
import { CartContext } from '../../../contexts/CartContext';
import Countdown from 'react-countdown';

const CommonTimer = () => {
	const { itemsCountstart, key, stage, alertTime } = useContext(CartContext);

	const [currentTime, setCurrentTime] = useState(itemsCountstart);
	const [forceUpdate, setForceUpdate] = useState(0);

	useEffect(() => {
		if (stage === 'extend' && alertTime) {
			setCurrentTime(alertTime);
		} else if (stage === 'checkout' && itemsCountstart) {
			setCurrentTime(itemsCountstart);
		} else if (itemsCountstart) {
			setCurrentTime(itemsCountstart);
		} else {
			setCurrentTime(null);
		}

		setForceUpdate((prev) => prev + 1);
	}, [itemsCountstart, key, stage, alertTime]);

	const renderer = ({ minutes, seconds, completed }) => {
		if (completed) {
			return null;
		} else {
			return (
				<span style={{ color: 'red', fontSize: '15px' }}>
					{minutes < 10 ? `0${minutes}` : minutes}:
					{seconds < 10 ? `0${seconds}` : seconds}
				</span>
			);
		}
	};

	if (!currentTime) {
		return null;
	}

	return (
		<Countdown date={currentTime} renderer={renderer} key={`${key}-${forceUpdate}-${stage}`} />
	);
};

export default CommonTimer;
